import React, { useEffect, useContext, useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';

import PbxContext from '../../context/PbxContext';
import logo from '../../img/logo.png';
import { accessLocalStorage, sendRebootSystem } from '../../services';

const Header = () => {
  const getItensStateGlobal = useContext(PbxContext);
  let { path, setPath, toggleIsChangeFormElements, toggleIsChangeFormElementsActive } = getItensStateGlobal;
  const history = useHistory();
  if(!path) path = history.location.pathname;
  const user = accessLocalStorage.getUserLocalStorage();
  if (!user) return null;
  const { user: { role } } = user;
  if(role === 'root') toggleIsChangeFormElements('config-items', 'navbar-dropdown mx-0 px-0 has-text-centered is-active');
  if(role === 'root') toggleIsChangeFormElements('troubleshooting-items', 'navbar-dropdown is-active');
  const { ipRequest } = user;
  const protocolUriActive = ipRequest.replace(/http/i, 'https');

  const verifyComponentView = useCallback(() => {
    const user = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = user;
    if(role === 'root') toggleIsChangeFormElements('config-items', 'navbar-dropdown mx-0 px-0 has-text-centered is-active');
    if(role === 'root') toggleIsChangeFormElements('troubleshooting-items', 'navbar-dropdown is-active');
    return;
  }, [toggleIsChangeFormElements]);

  const sendReboot = async () => {
    history.push('/home');
    await sendRebootSystem()
    return;
  };
  

  useEffect(() => {
    verifyComponentView();
  }, [verifyComponentView])
  
  return path !== '/' ? (
    <div className="navbar header-custon card-header" role="navigation" aria-label="main navigation">
      <div className="navbar-brand mr-6">
        <p className="navbar-item">
          <img src={logo} alt="logo" width="150" height="100" />
        </p>
      </div>
      <div className="navbar-menu">
        <div className="navbar-start">
          <Link to="/home" className="navbar-item has-text-weight-medium" onClick={() => setPath('/home')}>
            Home
          </Link>
        <div className="navbar-start">
          <Link to="/callcenter" className="navbar-item has-text-weight-medium" onClick={() => setPath('/callcenter')}>
            CallCenter
          </Link>
          <Link to="/agenda/lista" className="navbar-item has-text-weight-medium" onClick={() => setPath('/callcenter')}>
            Agenda
          </Link>
          <Link to={{ pathname: protocolUriActive }} target="_blank" className="navbar-item has-text-weight-medium">
            WebPhone
          </Link>
          {/* <Link to="/relatorios" className="navbar-item" onClick={() => setPath('/relatorios')}>
            Relatórios
          </Link> */}
          <Link to="/dashboard" className="navbar-item has-text-weight-medium" onClick={() => setPath('/dashboard')}>
            Dashboard
          </Link>
        <div className="navbar-item is-hoverable">
          <p className="navbar-link has-text-weight-medium">
            Configurações
          </p>
          <div id="config-items" name="config-items" className="has-background-white-bis navbar-dropdown is-hidden">
            <div name="config-dropdown-tenants" className="dropdown">
              <div className="dropdown-trigger">
                <Link to="#" className="dropdown-item button is-white" onClick={ () => toggleIsChangeFormElementsActive('config-dropdown-tenants') }>
                  Clientes
                </Link>
              </div>
              <div className="dropdown-menu" id="dropdown-menu-tenants" role="menu">
                <div className="dropdown-content has-background-light">
                  <Link to="/config/clientes/novo" className="dropdown-item"  onClick={ () => toggleIsChangeFormElementsActive('config-dropdown-tenants') }>
                    Adicionar Cliente
                  </Link>
                </div>
                <div className="dropdown-content has-background-light">
                  <Link to="/config/clientes/lista" className="dropdown-item"  onClick={ () => toggleIsChangeFormElementsActive('config-dropdown-tenants') }>
                    Listar Clientes
                  </Link>
                </div>
              </div>
            </div>
            <hr className="dropdown-divider"/>
            <div name="config-dropdown-network" className="dropdown">
              <div className="dropdown-trigger">
                <Link to="#" className=" button is-white dropdown-item" onClick={() => toggleIsChangeFormElementsActive('config-dropdown-network') }>
                  Redes
                </Link>
              </div>
              <div className="dropdown-menu" id="dropdown-menu-trunks" role="menu">
                <div className="dropdown-content">
                  <Link to="/config/rede/ip" className="dropdown-item" onClick={() => toggleIsChangeFormElementsActive('config-dropdown-network') }>
                    Alterar IP
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/rede/ip/lista" className="dropdown-item" onClick={() => toggleIsChangeFormElementsActive('config-dropdown-network') }>
                    IP/Interfaces
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/rede/ip/routes" className="dropdown-item" onClick={() => toggleIsChangeFormElementsActive('config-dropdown-network') }>
                    Configurar Rotas
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/rede/ip/routes/lista" className="dropdown-item" onClick={() => toggleIsChangeFormElementsActive('config-dropdown-network') }>
                    Status de Rotas
                  </Link>
                </div>
              </div>
            </div>
            <hr className="dropdown-divider"/>
            <div name="config-dropdown-endpoints" className="dropdown">
              <div className="dropdown-trigger">
                <Link to="#" className="dropdown-item button is-white"  onClick={() => toggleIsChangeFormElementsActive('config-dropdown-endpoints') }>
                  Ramais
                </Link>
              </div>
              <div className="dropdown-menu" id="dropdown-menu" role="menu">
                <div className="dropdown-content has-background-light">
                  <Link to="/config/ramal/novo" className="dropdown-item" onClick={() => toggleIsChangeFormElementsActive('config-dropdown-endpoints') }>
                    Criar Ramal
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/ramal/lista" className="dropdown-item" onClick={() => toggleIsChangeFormElementsActive('config-dropdown-endpoints') }>
                    Consultar Ramal
                  </Link>
                </div>
              </div>
            </div>
            <hr className="dropdown-divider"/>
            <div name="config-dropdown-trunks" className="dropdown">
              <div className="dropdown-trigger">
                <Link to="#" className="dropdown-item button is-white" onClick={() => toggleIsChangeFormElementsActive('config-dropdown-trunks') }>
                  Troncos
                </Link>
              </div>
              <div className="dropdown-menu" id="dropdown-menu-trunks" role="menu">
                <div className="dropdown-content has-background-light">
                  <Link to="/config/tronco/novo" className="dropdown-item" onClick={() => toggleIsChangeFormElementsActive('config-dropdown-trunks') }>
                    Criar Tronco
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/tronco/lista" className="dropdown-item" onClick={() => toggleIsChangeFormElementsActive('config-dropdown-trunks') }>
                    Consultar Tronco
                  </Link>
                </div>
              </div>
            </div>
            <hr className="dropdown-divider"/>
            <div name="config-dropdown-queues" className="dropdown">
              <div className="dropdown-trigger">
                <Link to="#" className="dropdown-item button is-white" onClick={ () => toggleIsChangeFormElementsActive('config-dropdown-queues') }>
                  Filas
                </Link>
              </div>
              <div className="dropdown-menu" id="dropdown-menu-queues" role="menu">
                <div className="dropdown-content has-background-light">
                  <Link to="/config/fila/nova" className="dropdown-item" onClick={ () => toggleIsChangeFormElementsActive('config-dropdown-queues') }>
                    Criar Fila
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/fila/lista" className="dropdown-item" onClick={ () => toggleIsChangeFormElementsActive('config-dropdown-queues') }>
                    Consultar Filas
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/fila/membros/novo" className="dropdown-item" onClick={ () => toggleIsChangeFormElementsActive('config-dropdown-queues') }>
                    Adicionar Membros a Filas
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/fila/membros/lista" className="dropdown-item" onClick={ () => toggleIsChangeFormElementsActive('config-dropdown-queues') }>
                    Consultar Membros/Filas
                  </Link>
                </div>
              </div>
            </div>
            <hr className="dropdown-divider"/>
            <div name="config-dropdown-dialplan" className="dropdown">
              <div className="dropdown-trigger">
                <Link to="#" className="dropdown-item button is-white" onClick={ () => toggleIsChangeFormElementsActive('config-dropdown-dialplan') }>
                  Chamadas
                </Link>
              </div>
              <div className="dropdown-menu" id="dropdown-menu-dialplan" role="menu">
                <div className="dropdown-content has-background-light">
                  <Link to="/config/direcionamentos/entrada" className="dropdown-item"  onClick={ () => toggleIsChangeFormElementsActive('config-dropdown-dialplan') }>
                    Entradas
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/direcionamentos/interno" className="dropdown-item" onClick={ () => toggleIsChangeFormElementsActive('config-dropdown-dialplan') }>
                    Internas
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/direcionamentos/externo" className="dropdown-item" onClick={ () => toggleIsChangeFormElementsActive('config-dropdown-dialplan') }>
                    Externas
                  </Link>
                </div>
              </div>
            </div>
            <hr className="dropdown-divider"/>
            <div name="config-dropdown-uploads" className="dropdown">
              <div className="dropdown-trigger">
                <Link to="#" className="dropdown-item button is-white" onClick={ () => toggleIsChangeFormElementsActive('config-dropdown-uploads') }>
                  Uploads
                </Link>
              </div>
              <div className="dropdown-menu" id="dropdown-menu-uploads" role="menu">
                <div className="dropdown-content has-background-light">
                  <Link to="/config/uploads" className="dropdown-item"  onClick={ () => toggleIsChangeFormElementsActive('config-dropdown-uploads') }>
                    Upload URA/Música de Espera
                  </Link>
                </div>
                <div className="dropdown-content has-background-light">
                  <Link to="/config/uploads/lista" className="dropdown-item"  onClick={ () => toggleIsChangeFormElementsActive('config-dropdown-uploads') }>
                    Listar URA/Música de Espera
                  </Link>
                </div>
              </div>
            </div>
            <hr className="dropdown-divider"/>
            <div name="config-dropdown-users" className="dropdown">
              <div className="dropdown-trigger">
                <Link to="#" className="dropdown-item button is-white" onClick={ () => toggleIsChangeFormElementsActive('config-dropdown-users') }>
                  Usuários
                </Link>
              </div>
              <div className="dropdown-menu" id="dropdown-menu-users" role="menu">
                <div className="dropdown-content has-background-light">
                  <Link to="/config/usuarios/novo" className="dropdown-item"  onClick={ () => toggleIsChangeFormElementsActive('config-dropdown-users') }>
                    Novo
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/usuarios/lista" className="dropdown-item" onClick={ () => toggleIsChangeFormElementsActive('config-dropdown-users') }>
                    Consultar
                  </Link>
                </div>
              </div>
            </div>
            <hr className="dropdown-divider"/>
            <div name="config-dropdown-system" className="dropdown">
              <div className="dropdown-trigger">
                <Link to="#" className="dropdown-item" onClick={() => toggleIsChangeFormElementsActive('config-dropdown-system') }>
                  Sistema
                </Link>
              </div>
              <div className="dropdown-menu" id="dropdown-menu-system" role="menu">
                <div className="dropdown-content has-background-light">
                  <Link to="/home" className="dropdown-item" onClick={() => sendReboot() }>
                    Reboot
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
        <div className="navbar-item has-dropdown is-hoverable" name="logs-vigoscloud">
          <p className="navbar-link has-text-weight-medium">
            Troubleshooting
          </p>
          <div id="troubleshooting-items" name="troubleshooting-items" className="navbar-dropdown is-hidden" >
            <Link to="/troubleshooting/sip" className="dropdown-item" onClick={() => toggleIsChangeFormElementsActive('dropdown-troubleshooting') }>
              Logs de Chamadas
            </Link>
            <hr className="dropdown-divider"/>
            <Link to="/troubleshooting/comandos" className="dropdown-item" onClick={() => toggleIsChangeFormElementsActive('dropdown-troubleshooting') }>
              Conectividade
            </Link>
          </div>
        </div>
        </div>
          <div className="navbar-end">
            <div className="navbar-item">
              <div className="buttons are-small py-0">
                <Link to="/" onClick={() => {
                  accessLocalStorage.removeUserItem();
                  setPath('/');
                }}
                >
                  <button className="button is-small py-0 is-primary">
                    Log out
                  </button>
                </Link>
              </div>
            </div>
          </div>
      </div>
      <a role="button" className="navbar-burger" aria-label="menu" aria-expanded="false" onClick={ () => toggleIsHidden('#navMenu') }>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
    )
    : null;
}

export default Header;